import { useMutation, useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { client } from '@frontend/features/common/services';

export interface WorkInterval { start: number; end: number }
export interface WorkCalendar {
  mode: 'custom' | 'inherit'; zone: string; week: WorkInterval[][];
  exceptions: Array<{date: string; intervals: WorkInterval[]}>;
}
export interface CalendarVersion extends WorkCalendar { id: string; kind: string; target: string; validFrom: string }
interface CalendarResult { calendar: CalendarVersion | null }
interface CalendarRoster {
  advisors: Array<{id: string; name: string}>; teams: Array<{id: string; name: string}>; truncated: boolean;
}
const path = (agency: number, kind: string, target: string) =>
  `workflow-performance/agencies/${agency}/calendars/${kind}/${encodeURIComponent(target)}`;
export function useCalendarRoster(userId: string | undefined, agency: number) {
  return useQuery<CalendarRoster, AxiosError>({
    queryKey: ['performance-calendar-roster', userId, agency],
    queryFn: async () => (await client.get(`workflow-performance/agencies/${agency}/calendars`, { timeout: 15000 })).data,
    enabled: Boolean(userId && agency), cacheTime: 0, retry: false, refetchOnWindowFocus: false, refetchOnReconnect: false,
  });
}
export function useCalendar(userId: string | undefined, agency: number, kind: string, target: string) {
  return useQuery<CalendarResult, AxiosError>({
    queryKey: ['performance-calendar', userId, agency, kind, target],
    queryFn: async () => (await client.get(path(agency, kind, target), { timeout: 15000 })).data,
    enabled: Boolean(userId && agency && target), cacheTime: 0, retry: false,
    refetchOnWindowFocus: false, refetchOnReconnect: false,
  });
}
interface CalendarInput extends WorkCalendar { revision: string | null }
export function useSaveCalendar(agency: number, kind: string, target: string) {
  const save = async (input: CalendarInput) => (await client.put(path(agency, kind, target), input, { timeout: 15000 })).data;
  return useMutation<CalendarResult, AxiosError, CalendarInput>(save, { retry: false });
}
